import { useTranslation } from 'react-i18next';

import { PartyDTO } from 'support/types';

import { Party } from './Party';

enum PartyType {
  Billing = 'billing',
  Delivery = 'delivery',
}

type BillingPartyProps = {
  selectedPartyId?: string;
  onSelectParty: (partyId: string) => void;
  parties: Array<PartyDTO> | undefined;
  onAddParty: (party: PartyDTO, onSuccess?: () => void) => void;
  onEditParty: (party: PartyDTO, onSuccess?: () => void) => void;
  disabled: boolean;
  error: string | null;
  clearError: () => void;
  isLoading: boolean;
};

export function BillingParty({
  parties,
  selectedPartyId,
  onSelectParty,
  onAddParty,
  onEditParty,
  disabled,
  error,
  clearError,
  isLoading,
}: BillingPartyProps) {
  const { t } = useTranslation();
  const validParties =
    parties?.filter((party) =>
      party.identifiers?.some(
        (identifier) => (identifier.domain === 'GS1' || identifier.domain === 'vatID') && !!identifier.identifier,
      ),
    ) || [];
  return (
    <>
      <p className="text-base font-bold leading-6 text-gray-900">{t('orderForms:checkout.billingAddress')}</p>
      <Party
        selectedPartyId={selectedPartyId}
        parties={validParties}
        partyType={PartyType.Billing}
        onSelectParty={onSelectParty}
        onAddParty={onAddParty}
        onEditParty={onEditParty}
        disabled={disabled}
        error={error}
        clearError={clearError}
        isLoading={isLoading}
      />
    </>
  );
}
